<template>
	<div class="page">

		<scroll-to :links="scrollTo"></scroll-to>


		<div class="page-content-wrap">
			

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>


				<div class="row">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work">
						<sortableImages @exportImages="exportImages"  :images="www.images"></sortableImages>
					</div>
				</div>


				<div class="row">
					<h3 id="s5" class="title-steps">Тип</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.type" :where="'soft/type/search'" @exportList="exportTypes"></form-list>
					</div> 
				</div>

				<div class="row">
					<h3 id="s3" class="title-steps">Опции</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="15" :filters="www.options" :where="'soft/option/search'" @exportList="exportOption"></form-list>
					</div>
				</div>

				<div class="row"> 
					<h3 id="s2" class="title-steps">Значение за опции</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.stateFormptions" @exportMeta="exportFormOptions" :formElements="formOptions"></forms>
						<div v-else>
							<p>Избери опции</p>
						</div>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Мета дани</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.openForms" :formElements="formElements" @exportMeta="exportMeta" ></forms>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Доп. елементи</h3>
					<div class="col-lg-12 section-work">
						<soft-element @exportElements="exportAdditionalElements" ></soft-element>
					</div>
				</div>

				<div class="row">
					<h3 id="s4" class="title-steps">Особенности</h3> <div class="col-lg-12 section-work">
						<form-list :limit="7" :filters="www.qualities" :where="'soft/qualities/search'" @exportList="exportQualities"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s4" class="title-steps">Модел</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.product" :where="'shop/product/search'" @exportList="exportProducts"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s5" class="title-steps">Производител</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="1" :filters="www.brand" :where="'shop/brand/search'" @exportList="exportBrands"></form-list>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Цена</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.stateformMaterials"  :formElements="formMaterials" @exportMeta="exportFormMaterials"></forms>

						<div v-else>
							<p>Избери производител</p>
						</div>
					</div>
				</div>

			</div>

			
		</div>
		
		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>
	
	import ModalCreateFolder from "../../../app_modules/ModalCreateFolder";


	import ScrollTo from '../../../../components/layouts/ScrollTo'
	import Errors from '../../../../components/app_modules/Errors'
	import BottomMenu from '../../../../components/app_modules/BottomMenu'
	
	import SortableImages from '../../../../components/app_modules/SortableImages'
	import SortableCategory from '../../../../components/app_modules/SortableCategory'

	import SortableProducts from '../../../../components/app_modules/SortableProducts.vue'

	import FormList from '../../../../components/app_modules/FormList'


	import SoftElement from '../../../../components/app_modules/SoftElement'
	import Forms from '../../../../components/app_modules/Forms'
	import Editor from '../../../../components/app_modules/Editor'
	//import SortableCategory from '../../../components/app_modules/SortableCategory'

	import axios from 'axios'

	export default {
		name: 'soft-module-create',

		
		data() {
			return {
				productPage: true,
				modalCreateFolder: false,
				openForms:false,
				stateformMaterials:false,
				stateFormptions: false,
				//serverErrors: null,

				dataStore: [],
				formStore: [],

				www: {
					link_send: this.$store.getters.getDomainName+'soft/module',
					method: 'post',
					redirect: 'soft-module',

					status: 'true',
					product: [],
					brand: [],
					type:[],
					qualities: [],
					seat_width:[],
					seat_count:[],
					images: [],
					dataOptions:[],
					options:[],
					materials: [],
					elementGroupsOfModule: [],
					description: `<p>qwdqwd</p>`,
					dataMaterials: [],

				},
				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'title',
					placeholder: 'title',
					model: '',
					readonly: true
				},
				{
					id: 1,
					type: 'input',
					name: 'code',
					placeholder: 'code',
					model: '',
					readonly: true
				},
				{
					id: 2,
					type: 'input',
					name: 'link',
					placeholder: 'link',
					model: '',
					readonly: true
				},
				{
					id: 3,
					type: 'input',
					name: 'poss',
					placeholder: 'poss',
					model: '',
					readonly: true
				},
				{
					id: 4,
					type: 'input',
					name: 'seat_width',
					placeholder: 'Длина на сидалка',
					model: '',
					readonly: true
				},
				{
					id: 5,
					type: 'input',
					name: 'seat_count',
					placeholder: 'Кол-во за сидалки',
					model: '',
					readonly: true
				},


				{
					id: 6,
					type: 'status',
					name: 'status',

					model: true,
				},
				


				],

				formMaterials: [{},],

				formOptions: [{},],


				scrollTo: [
				{
					id: 1,
					name: ' Снимка',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Мета дани',
					href: '#s2',
				},
				{
					id: 3,
					name: 'Описание',
					href: '#s3',
				},

				{
					id: 4,
					name: 'Модел',
					href: '#s4',
				},
				
				]
			}
		},
		methods: {
			exportAdditionalElements(data) {
				this.www.additionalElements = data
			},
			exportFormOptions(data) {
				this.generateData('dataOptions', data)
			},
			exportTypes(data) {
				this.www.type = data
			},
			exportQualities(data) {
				this.www.qualities = data
			},
			exportOption(data) {
				data = data.reverse()

				this.formOptions.push({ 

					id: data[0].id,
					ids: data[0].id,
					type: 'input',
					name: data[0].title,
					placeholder: 'цена за ' + data[0].title,
					model: data[0].value,
					readonly: true,
					selected: true,
				})
				this.stateFormptions = true

			},

			exportProducts(data) {
				this.www.product = data
			},
			exportBrands(data) {
				this.www.brand = data

				var url ='soft/material/group/search/brand/'+data[0].id

				this.formMaterials = []
				this.importData('formMaterials',url)


			},
			exportContent(data) {
				this.www.description = data
			},

			exportMeta(data) {
				console.log(data)
				this.www.title = data[0].model
				this.www.code = data[1].model
				this.www.link = data[2].model
				this.www.poss = data[3].model
				this.www.seat_width = data[4].model
				this.www.seat_count = data[5].model
				this.www.status = data[6].model
			},

			exportFormMaterials(data)
			{
				this.www.materials = data
				this.generateData('dataMaterials', data)
				
			},

			exportImages(data, url) {
				this.www.images = data
			},
			// importData : async(url) => {
				importData(nameObject, url) {

					axios.get(this.$store.getters.getDomainName+url)
					.then(response => {

						this.generateForm(nameObject, response.data)

					})
					.catch(error => {

					})

				},

				generateForm(nameObject, data) {

					if(nameObject == 'formOptions') {
						this.formOptions = []
					} 
					if(nameObject == 'formMaterials') {
						this.formMaterials = []
					}

					var formData = [];

					for (var i = data.length - 1; i >= 0; i--) {

						if(data[i].title != '') {

							if(!data[i].value) {
								data[i].value = '' 
							}
							if(data[i].price) {
								data[i].value = data[i].price
							}

							formData.push({ 

								id: data[i].id,
								ids: data[i].id,
								type: 'input',
								name: data[i].title,
								placeholder: 'цена за ' + data[i].title,
								model: data[i].value,
								readonly: true,
								selected: true,
							})
						}
					}

				if(nameObject == 'formOptions') {
					this.formOptions = formData
					this.stateFormptions = true

				} 
				if(nameObject == 'formMaterials') {
					this.formMaterials = formData
					this.stateformMaterials = true

				}

			},

			generateData(nameObject, form) {
		

				
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = []
				}
				if(nameObject == 'dataOptions') {
					this.dataOptions = []
				}

				var data = [];

				for (var i = form.length - 1; i >= 0; i--) {



						data.push({ 

							id: form[i].id,
							id: form[i].ids,
							title: form[i].name,
							value: form[i].model,
						})
				}
	
				if(nameObject == 'dataOptions') {
					this.www.dataOptions = data
					
				}
				if(nameObject == 'dataMaterials') {
					this.www.dataMaterials = data

					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
					console.log(this.dataMaterials)
				}


			},




		},
		computed: {

		},
		created() {
			eventBus.$on('closeModalCreateFolder', data => {
				this.modalCreateFolder = data
			})

			// this.getMaterials()
			// this.getTypes()
			

			if(this.$route.name == 'soft-module-edit') {

				axios.get(this.$store.getters.getDomainName+'soft/module/'+this.$route.params.id+'/edit')

				.then(response => {

					this.www.title = response.data['title']
					this.www.code = response.data['code']
					this.www.link = response.data['link']
					this.www.poss = response.data['poss']
					// this.www.type = response.data['type']
					this.www.type = response.data['type']
					// this.www.options = response.data['options']
					this.www.brand = response.data['brand']
					this.www.product = response.data['product']
					this.www.seat_width = response.data['seat_width']
					this.www.seat_count = response.data['seat_count']

					this.generateForm('formOptions', response.data['options'])
					this.www.dataOptions = response.data['options']
					this.www.options = response.data['options']
					this.www.qualities = response.data['qualities']
					this.www.dataMaterials = response.data['soft_material_groups']
					
					this.generateForm('formMaterials', response.data.soft_material_groups)

					// send active category
					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						if(images[i] != '') {
							this.www.images.push({ 
								icon: images[i],
								id: i,
							})
						}
					}
					this.formElements[0].model = response.data['title'] 
					this.formElements[1].model = response.data['code'] 
					this.formElements[2].model = response.data['link'] 
					this.formElements[3].model = response.data['poss'] 
					this.formElements[4].model = response.data['seat_width'] 
					this.formElements[5].model = response.data['seat_count'] 
					this.formElements[6].model = response.data['status'] 

					this.www.product = response.data['product']
					this.www.brand = response.data['brand']

					var materials = response.data['materialPrices']



					console.log(materials)

					response.data['status'] == 0 ? this.formElements[6].model = false : this.formElements[6].model = true


					if(response.data['status'] == 0) {
						this.formElements[6].model = false
					} else {
						this.formElements[6].model = true
					}

					this.www.link_send = this.$store.getters.getDomainName+'soft/module/'+this.$route.params.id
					this.www.method = 'patch'

					eventBus.$emit('sendLinkAndMethod', this.www)

					this.openForms = true
					this.stateformMaterials = true

					return


				})
				.catch(error => {

				})


			} else {
				this.openForms = true
					// this.stateformMaterials = true

				}
			},
			beforeDestroy() {
				eventBus.$off('closeModalCreateFolder')
			},
			components: {
				ModalCreateFolder,
				Forms,
				ScrollTo,
				Editor,
			//SortableCategory,
			Errors,
			BottomMenu,
			SortableImages,
			SortableCategory,
			SortableProducts,
			FormList,
			SoftElement,
		},

	}
</script>

<style scoped src="../../../../assets/css/page-data.css"></style>


// WEBPACK FOOTER //
// src/components/soft/module/sofa/data.vue